import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, DollarSign, BarChart3, Users, Target, TrendingUp, LayoutGrid } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import servicesData from '../data/services.json';

// Mapeamento de ícones para cada serviço (opcional, deixa mais moderno)
const icons = {
  "dashboards-trafego-pago-customizados": <Target size={32} />,
  "gestao-de-retencao-para-agencias": <Users size={32} />,
  "bi-vendas-e-performance": <BarChart3 size={32} />,
  "comparativos-e-previsoes": <TrendingUp size={32} />,
  "monitoramento-multi-contas-ads": <LayoutGrid size={32} />
};

const Services = () => {
  const { t } = useTranslation();
  
  return (
    <div className="page-services">
      <section className="services-hero">
        <div className="services-hero-container">
          <h1 className="page-title">{t('services.pageTitle')}</h1>
          <p className="page-subtitle">{t('services.pageSubtitle')}</p>
        </div>
      </section>

      <section className="services-catalog">
        <div className="services-container">
          <div className="bento-grid">
            {servicesData.map((service, index) => (
              <Link 
                key={service.id} 
                to={`/services/${service.slug}`} 
                className={`bento-item item-${index + 1}`}
              >
                <div className="bento-content">
                  <div className="bento-icon">
                    {icons[service.id] || <BarChart3 size={32} />}
                  </div>
                  <div className="bento-info">
                    <h3 className="bento-title">{service.title}</h3>
                    <p className="bento-description">{service.shortDescription}</p>
                  </div>
                  
                  <div className="bento-footer">
                    <div className="bento-meta">
                      <span className="meta-badge"><Clock size={14} /> {service.timeline}</span>
                      <span className="meta-badge"><DollarSign size={14} /> {service.price}</span>
                    </div>
                    <div className="bento-arrow">
                       <ArrowRight size={20} />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="services-cta">
        <div className="services-cta-container">
          <h2 className="services-cta-title">{t('services.ctaTitle')}</h2>
          <p className="services-cta-subtitle">{t('services.ctaSubtitle')}</p>
          <a href="https://wa.me/5588996527079" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large">
            {t('services.scheduleConversation')}
            <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;